import _last from 'lodash/last';
import _toUpper from 'lodash/toUpper';
import _join from 'lodash/join';

export const convertFileSize = size => {
    let unit = 'B';
    let convertedFileSize = size;
    if (size > 999999999) {
        unit = 'GB';
        convertedFileSize = Number(size / 1000000000).toFixed(1);
    } else if (size > 999999) {
        unit = 'MB';
        convertedFileSize = Number(size / 1000000).toFixed(1);
    } else if (size > 999) {
        unit = 'kB';
        convertedFileSize = Number(size / 1000).toFixed(1);
    }

    return { size: convertedFileSize, unit };
};

export const getFileTypeLabels = (typeStr = '') => {
    const typeArr = typeStr.split('/');
    const type = _toUpper(_last(typeArr));

    const label = type ? type : 'DOC';
    let labelLong = 'Document';

    switch (type) {
        case 'PNG':
        case 'JPG': {
            labelLong = 'Image';
            break;
        }
        default: {
            // do nothing
        }
    }
    return { label, labelLong };
};

export const getFileTypeLabelsByFilename = (filename = '') => {
    const fileParts = filename.split('.');
    const ext = _toUpper(_last(fileParts));

    const label = ext ? ext : 'DOC';
    let labelLong = 'Document';

    switch (ext) {
        case 'PNG':
        case 'JPG':
        case 'JPEG': {
            labelLong = 'Image';
            break;
        }
        default: {
            // do nothing
        }
    }
    return { label, labelLong };
};

const FILENAME_SUFFIX_PROFILE_PIC = '200x200';
const FILENAME_SUFFIX_BANNER = '1920x1920';
const RESIZED_FILE_EXT = 'jpeg';

export const getResizedProfilePicFilename = (filename = '') => {
    return getResizedImageFilename(filename, FILENAME_SUFFIX_PROFILE_PIC);
};

export const getResizedBannerFilename = (filename = '') => {
    return getResizedImageFilename(filename, FILENAME_SUFFIX_BANNER);
};

export const getResizedImageFilename = (filename = '', suffix = '', ext = RESIZED_FILE_EXT) => {
    const fileParts = filename.split('.');

    if (fileParts.length > 1) {
        // it contains an extension
        // const ext = _last(fileParts);
        const nameParts = [...fileParts];
        nameParts.pop(); // remove last element, which is the extension
        const name = _join(nameParts, '.'); // put the filename back together (minus the extension)
        return `${name}_${suffix}.${ext}`;
    } else {
        // no extension
        return `${filename}_${suffix}`;
    }
};
